import { useEffect, useState } from 'react';
import { jobService } from 'services/job.service';

const usePilotAvailableJobs = (payload = { skip: 0, limit: 5 }, pilotRadius) => {
    const [jobs, setJobs] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const handleApi = async () => {
        try {
            setIsLoading(true);
            const response = await jobService.getPilotAvailableJobs(payload);
            setJobs(response.data.data)
        } catch (err) {
            console.log(err)
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (payload) {
            handleApi();
        }
    }, [pilotRadius, payload?.limit]);

    return { jobsData: jobs, isLoading };
}

export default usePilotAvailableJobs;